<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item, index) in levelList" :key="item.path">
        <span v-if="index === levelList.length-1" class="no-redirect">{{ item.meta.title.replace(/利息/g, '延期费用') }}</span>
        <a v-else @click.prevent="handleLink(item)">{{ item.meta.title.replace(/利息/g, '延期费用') }}</a>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
export default {
  name: 'Breadcrumb',
  data() {
    return {
      levelList: null
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  created() {
    this.getBreadcrumb()
  },
  methods: {
    getBreadcrumb() {
      let matched = this.$route.matched.filter(item => item.meta && item.meta.title)
      const first = matched[0]

      // 如果首页不是Dashboard，则把它添加为第一个
      if (!this.isDashboard(first)) {
        matched = [{ path: '/dashboard', meta: { title: '首页' } }].concat(matched)
      }

      this.levelList = matched
    },
    isDashboard(route) {
      const name = route && route.name
      if (!name) return false
      return name.trim().toLowerCase() === 'Dashboard'.toLowerCase()
    },
    // 路由跳转
    handleLink(item) {
      const { path } = item
      this.$router.push(path)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.app-breadcrumb {
  display: inline-block;
  line-height: 56px;
  margin-left: 4px;
  white-space: nowrap;
  vertical-align: middle;

  ::v-deep .el-breadcrumb {
    line-height: 56px;
    font-size: 14px;
  }

  ::v-deep .el-breadcrumb > span {
    display: inline;
  }

  ::v-deep .el-breadcrumb__item {
    float: left;
  }

  ::v-deep .el-breadcrumb__inner,
  ::v-deep .el-breadcrumb__inner a {
    font-weight: normal;
    color: rgba(255, 255, 255, 0.92);
    cursor: pointer;

    &.is-link:hover {
      color: #3dd9a5;
    }
  }

  ::v-deep .el-breadcrumb__separator {
    color: rgba(255, 255, 255, 0.45);
  }
  
  .no-redirect {
    color: rgba(255, 255, 255, 0.75);
    cursor: text;
  }
}
</style>
